import en from './en.json'
import ja from './ja.json'

const locales: {[locale: string]: {[message_id: string]: string}}  = {
    en: en,
    ja: ja,
};

export default locales;